export const CUSTOM_OPTION_OPEN = "CUSTOM_OPTION_OPEN";
export const CUSTOM_OPTION_VALUES = "CUSTOM_OPTION_VALUES";
export const READY_FOR_ADD = "READY_FOR_ADD";